import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { withProps } from '../withProps.js';

const IconFeatherChevronUp = withProps(props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.52851 5.52858C7.78886 5.26823 8.21097 5.26823 8.47132 5.52858L12.4713 9.52858C12.7317 9.78892 12.7317 10.211 12.4713 10.4714C12.211 10.7317 11.7889 10.7317 11.5285 10.4714L7.99992 6.94279L4.47132 10.4714C4.21097 10.7317 3.78886 10.7317 3.52851 10.4714C3.26816 10.211 3.26816 9.78892 3.52851 9.52858L7.52851 5.52858Z",
  fill: "currentColor"
})));
IconFeatherChevronUp.displayName = 'IconFeatherChevronUp';

export { IconFeatherChevronUp };
